const Component = {
  "图片 url 不存在": "La URL de la imagen no existe",
  "暂不支持下载此类型图片": "Por el momento no se admite la descarga de este tipo de imagen",
}
  
export default Component;